import CastRankingRes from "types/res/castRanking/CastRankingRes";

export default class CastRankingEachDataRes {
  readonly [key: number]: CastRankingRes;
}
